// src/components/company/CompanyProfileForm.jsx

import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { fetchCompanyById, updateCompanyById  } from "../../api/companyApi";

const CompanyProfileForm = ({ onSubmit, initialValues = {}, isEdit = false }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [message, setMessage] = useState({ type: "", text: "" });

  const getDefaultFormData = () => ({
    name: "",
    industry: "",
    website: "",
    description: "",
    location: "",
    size: "",
    logo_url: "",
    createdBy: localStorage.getItem("aUid"),
    updatedBy: "",
  });

  const copiedCompany = location.state?.copiedCompany;

  const [formData, setFormData] = useState({
    ...getDefaultFormData(),
    ...initialValues,
    ...copiedCompany,
  });

  useEffect(() => {

      if (isEdit && id) {
        const fetchCompany = async () => {
          try {
            const token = localStorage.getItem("otoken");

            // Call the utility function to fetch company by ID
            const companyData = await fetchCompanyById(id, token);
            
            setFormData(companyData);  // Set company data in form state
          } catch (err) {
            console.error("Error fetching company:", err);
            setMessage({ type: "error", text: "Failed to load company info" });
          }
        };

        fetchCompany();
      }
    
  }, [isEdit, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => setFormData(getDefaultFormData());

  const handleSubmit = async () => {
  const token = localStorage.getItem("otoken");

  const payload =
      formData.company_logo instanceof File
        ? (() => {
            const form = new FormData();
            for (let key in formData) {
              if (formData[key] !== null && formData[key] !== undefined) {
                form.append(key, formData[key]);
              }
            }
            return form;
          })()
        : formData;

    try {
      const res = await updateCompanyById(id, payload, token);
      setMessage({ type: "success", text: "Company updated!" });
    } catch (err) {
      setMessage({ type: "danger", text: "Failed to update company profile" });
    }
  };


  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setFormData((prevData) => ({
        ...prevData,
        logoPreview: previewUrl,
        company_logo: file, // Update with actual file object
      }));
    }
  };


  const logoUrl = formData.company_logo
    ? `${process.env.REACT_APP_JOB_BOARD_UPLOAD_URL}/${formData.company_logo}`
    : null;

  return (
    <div className="content-body">
      {/* <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="javascript:void(0)">Company Profile</a>
            </li>
            <li className="breadcrumb-item active">
              <a href="javascript:void(0)">Edit</a>
            </li>
          </ol>
        </div>
      </div> */}

      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className={`alert alert-${message.type} mt-3`} role="alert">
                  {message.text}
                </div>
                <div className="form-validation">
                  <form onSubmit={handleSubmit} className="form-validate">
                    <div className="form-group row">

                      <label className="col-lg-4 col-form-label" htmlFor="companyLogo">
                        Company Logo <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-6">
                        {(formData.logoPreview || logoUrl) && (
                          <img
                            src={formData.logoPreview || logoUrl}
                            alt="Company Logo"
                            className="mb-3"
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        )}

                        <input
                          type="file"
                          id="companyLogo"
                          name="company_logo"
                          className="form-control-file"
                          accept="image/*"
                          onChange={handleLogoChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="companyName">Company Name <span className="text-danger">*</span></label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="company_name"
                          value={formData.company_name || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="address">Address</label>
                      <div className="col-lg-6">
                        <input
                          type="text"
                          className="form-control"
                          name="company_address"
                          value={formData.company_address || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="website">Website</label>
                      <div className="col-lg-6">
                        <input
                          type="url"
                          className="form-control"
                          name="company_website"
                          value={formData.company_website || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="contactEmail">Contact Email</label>
                      <div className="col-lg-6">
                        <input
                          type="email"
                          className="form-control"
                          name="contact_us"
                          value={formData.contact_us || ""}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="username">About Us</label>
                      <div className="col-lg-6">
                        <textarea
                          className="form-control"
                          name="company_description"
                          value={formData.company_description || ""}
                          onChange={handleChange}
                          rows="4"
                        />
                      </div>
                    </div>

                    <div className="text-end">
                      <button type="submit" className="btn btn-primary me-2">
                        Save
                      </button>
                     <button
                        type="button"
                        className="btn btn-secondary mr-2"
                        onClick={() => navigate("/company/company-profile/profile")}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfileForm;
